module.exports = __webpack_public_path__ + "static/user-testing-2-mobile-c8cb6ec0131185f6eca65f2b0acf106c.jpg";